import { Component, OnInit } from '@angular/core';
import { Router, Params } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { FeatureService } from '../../common/feature.service';
import { FeatureOptionFormComponent } from '../feature-option-form/feature-option-form.component';
import { MdDialog } from '@angular/material';

@Component({
  selector: 'feature-options',
  templateUrl: './feature-options.component.html',
  styleUrls: ['./feature-options.component.css', '../../app.component.css'],
  providers: [FeatureService]
})
export class FeatureOptionsComponent implements OnInit {

  eventId: any;
  featureId: any;
  featureOptions: any;
  featureOptionId: any;
  featureOption: any;
  spinner: boolean = false;

  constructor(private formBuilder: FormBuilder, private featureService: FeatureService, public dialog: MdDialog){
  }

  ngOnInit() {
  }

  getFeatureOptions(){
   this.spinner = true;
   this.featureService.getFeatureOptions(this.featureId).subscribe(
    response => {
     this.spinner = false;
     this.featureOptions = response;
    },
    error => {
     this.spinner = false;
    }
   );
  }

  featureOptionFormDialog(params) {
    if(params && params.id)
    this.featureOptionId = params.id;
    else
    this.featureOptionId = 0;
    let dialogRef = this.dialog.open(FeatureOptionFormComponent);
    dialogRef.componentInstance.eventId = this.eventId;
    dialogRef.componentInstance.featureId = this.featureId;
    if(this.featureOptionId)
    {
     this.featureService.findFeatureOption(this.featureOptionId).subscribe(response => {
      dialogRef.componentInstance.featureOption = response[0];
     });
    }
    else
    dialogRef.componentInstance.featureOption = dialogRef.componentInstance.featureOptionForm.value;
    dialogRef.componentInstance.onSave.subscribe(() => {
     this.getFeatureOptions();
     dialogRef.close();
    });
  }

  deleteFeatureOption(params){
   if(confirm('Are you sure?'))
   {
    this.spinner = true;
    this.featureService.deleteFeatureOption(params).subscribe(
     response => {
      this.spinner = false;
      if(response.status)
      this.getFeatureOptions();
     },
     error => {
      this.spinner = false;
     }
    );
   }
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/feature-options/feature-options.component.ts